/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addr_Method_RegionInputs */

const cs_addr_method_region = /** @type {(inputs: Addr_Method_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RÚIAN · kraj z polohy`)
};

const en_addr_method_region = /** @type {(inputs: Addr_Method_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RÚIAN · region from location`)
};

/**
* | output |
* | --- |
* | "RÚIAN · region from location" |
*
* @param {Addr_Method_RegionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_method_region = /** @type {((inputs?: Addr_Method_RegionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Method_RegionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_method_region(inputs)
	return cs_addr_method_region(inputs)
});